/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'necktie': {
    width: 404,
    height: 404,
    viewBox: '-92 0 404 404.167',
    data: '<path pid="0" d="M94.34 124h30.562l5.657-24.094L109.62 82.06 88.668 99.855zm0 0M.082 27.809l44.246 90.812L96.84 74.38zm0 0M94.844 138L62.836 353.246l46.785 50.922 46.785-50.922L124.398 138zm0 0M174.918 118.621L219.16 27.81l-96.754 46.57zm0 0M214.738 14.266A398.655 398.655 0 00109.61 0h-.191A399.42 399.42 0 004.355 14.16l105.266 50.77zm0 0"/>'
  }
})
